<template>
  <v-card>
    <v-card-title>
      List of Active Devices ({{ items.length }})
      <v-btn small icon @click="dataRefresh">
        <v-icon>refresh</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search">
      </v-text-field>
    </v-card-title>
    <v-progress-linear
      :indeterminate="true"
      :active="showProgress">
    </v-progress-linear>
    <v-data-table
      v-bind:headers="headers"
      v-bind:items="items"
      v-bind:search="search"
      v-bind:rows-per-page-items="rowsPerPage">
      <template slot="items" slot-scope="props">
        <td class="layout px-0">
          <v-btn small icon :to="{name: 'deviceEdit',
            params: { id: props.item.deviceRecordId, deviceId: props.item.deviceId }}">
            <v-icon small color="grey">more_horiz</v-icon>
          </v-btn>
          <v-btn small icon :to="{name: 'dashboard'}" v-if="shouldDisplay('view_dashborad_from_device_list')">
            <v-icon small color="grey">dashboard</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-left">{{ props.item.serial }}</td>
        <td class="text-xs-left" v-if="props.item.careUser">{{ props.item.careUser.firstName }} {{ props.item.careUser.lastName}}
          <v-btn small icon :to="{name: 'careUserEdit', params: { id: props.item.careUserId }}">
            <v-icon small color="grey">keyboard_arrow_right</v-icon></v-btn>
        </td>
        <td class="text-xs-left" v-else>Device Unassigned</td>
        <td class="text-xs-left">{{ props.item.deviceId }}</td>
        <td class="text-xs-left">{{ props.item.made }}</td>
        <td class="text-xs-left">{{ props.item.model }}</td>
        <td class="text-xs-left">{{ props.item.stateType.description }}</td>
        <td class="text-xs-left" v-if="props.item.careGroup">{{ props.item.careGroup.name }}</td>
        <td class="text-xs-left" v-else>Device Unasignned</td>
        <td class="text-xs-left" v-if="shouldDisplay('/deviceUpdate')">
          <v-dialog v-model="dialog" max-width="500px" hide-overlay lazy>
            <v-btn small icon slot="activator" @click.native="
              deleteId = props.item.deviceRecordId,
              deleteDevice = props.item.deviceId,
              dialog = true">
              <v-icon small color="grey">delete</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                Do you want to set the device
                <div class="red--text subheading">
                    {{ deleteDevice }}
                </div>to inactive
              </v-card-text>
              <v-spacer></v-spacer>
              <v-btn dark color="blue darken-1"
                @click.native="dialog = false">CANCEL</v-btn>
              <v-btn dark color="red darken-1"
              @click.native="inactivate()">CONFIRM INACTIVE</v-btn>
            </v-card>
          </v-dialog>
        </td>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
    <div class="red white--text subheading">{{ errMsg }}</div>
  </v-card>
</template>

<script>
  import mixins from '@/mixins.js'
  import DeviceService from '@/services/DeviceService'

  export default {
    data() {
      return {
        errMsg: '',
        deleteId: 0,
        deleteDevice: '',
        showProgress: true,
        dialog: false,
        tmp: '',
        search: '',
        selected: [],
        pagination: {},
        rowsPerPage: [
          20,
          40,
          {"text": "All", "value": -1}
        ],
        headers: [
          {
            text: 'Edit',
            align: 'left',
            sortable: false,
          },
          { text: 'Serial', align: 'left', value: 'serial' },
          { text: 'Weared by Care User', align: 'left', value: 'careUser.firstName' },
          { text: 'Device ID', align: 'left', value: 'deviceId' },
          { text: 'Made', align: 'left', value: 'made' },
          { text: 'Model', align: 'left', value: 'model' },
          { text: 'State', align: 'left', value: 'stateType.description' },
          { text: 'Owned by Care Group', align: 'left', value: 'careGroup.name' },
          { text: 'De-activate',
            align: 'left',
            sortable: false
          }
        ],
        items: [],
      }
    },
    mixins: [mixins],
    async mounted() {
      try {
        this.dialog = false
        this.errMsg = ''
        this.showProgress = true
        this.items = (await DeviceService.index()).data
        if (!this.shouldDisplay('/deviceUpdate')) {
          this.headers.splice(8,1)
        }
        this.showProgress = false
      } catch (error) {
        this.showProgress = false
        this.errMsg = this.handleError(error)
      }
    },
    methods: {
      async inactivate() {
        try {
          this.dialog = false
          this.errMsg = ''
          const response = await DeviceService.state({
            deviceRecordId: this.deleteId,
            state: 1
          })
          this.showProgress = true
          this.items = (await DeviceService.index()).data
          if (!this.shouldDisplay('/deviceUpdate')) {
            this.headers.splice(8,1)
          }
          this.showProgress = false
        } catch (error) {
          this.showProgress = false
          this.errMsg = this.handleError(error)
        }
      },
      async dataRefresh() {
        try {
          this.dialog = false
          this.errMsg = ''
          this.showProgress = true
          this.items = (await DeviceService.index()).data
          if (!this.shouldDisplay('/deviceUpdate')) {
            this.headers.splice(8,1)
          }
          this.showProgress = false
        } catch (error) {
          this.showProgress = false
          this.errMsg = this.handleError(error)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Device/DeviceList.vue